import { useState } from 'react';
import { useInit } from '../../../../../Contexts/InitProvider';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, {
    InputCheckbox,
    SelectOption,
    addOption
} from '../../../../../utils/InputField';
import { TextCapitalize } from '../../../../../utils/TextFormatter';
import { handleUpdatePackageOpe } from '../../ProductOperation';

const limitBy = [
    {
        key: 'duration',
        title: 'Duration'
    },
    {
        key: 'ppu',
        title: 'Pay Per Unit'
    },
    {
        key: 'lifetime',
        title: 'Life Time'
    }
];

function UpdatePackageModal({ closeModal, handleReload, data }) {
    const { id, applicationId, packageName, role, status, isPublic } = data || {};
    const [formData, setFormData] = useState({
        ApplicationId: applicationId,
        PackageName: packageName,
        LimitBy: limitBy?.find((el) => el.key === data?.limitBy)?.key,
        Role: role,
        Status: status,
        IsPublic: isPublic
    });
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');

    const { initInfo } = useInit();
    const { setMessage } = useTemplate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'IsPublic') {
            setFormData((d) => ({ ...d, [name]: !formData.IsPublic }));
            return;
        }
        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleEditCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        handleUpdatePackageOpe(applicationId, id, formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleEditCustomer}>
            <div className="flex flex-col gap-y-3 mb-4">
                <InputField
                    label="Package Name"
                    name="PackageName"
                    placeholder="Enter Package Name..."
                    formData={formData}
                    onChange={handleChange}
                />

                <SelectOption
                    label="Role"
                    name="Role"
                    formData={formData}
                    onChange={handleChange}
                    options={initInfo?.roles
                        ?.filter((el) => el.key !== 'admin')
                        ?.map((item) => addOption(item?.key, item?.title, item?.key))}
                />

                <InputField
                    label="Limit By"
                    name="LimitBy"
                    formData={{
                        LimitBy: limitBy?.find(({ key }) => key === formData?.LimitBy)?.title
                    }}
                    onChange={handleChange}
                    disabled
                />

                <SelectOption
                    label="Status"
                    name="Status"
                    formData={formData}
                    onChange={handleChange}
                    options={['active', 'inactive']?.map((item) =>
                        addOption(item, TextCapitalize(item), item)
                    )}
                />

                <InputCheckbox
                    label="IsPublic"
                    name="IsPublic"
                    formData={formData}
                    onChange={handleChange}
                    text="Is This Package Public?"
                />
            </div>

            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default UpdatePackageModal;
